import { render } from "./Prognoz.vue?vue&type=template&id=c823abba&scoped=true"
import script from "./Prognoz.vue?vue&type=script&lang=js"
export * from "./Prognoz.vue?vue&type=script&lang=js"

import "./Prognoz.vue?vue&type=style&index=0&id=c823abba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c823abba"]])

export default __exports__